__turbopack_context__.v({
  "acheivergreyrank": "tnpsc-group-gs-mains-test-series-2023-module__HT_osa__acheivergreyrank",
  "acheivername": "tnpsc-group-gs-mains-test-series-2023-module__HT_osa__acheivername",
  "admissiongreencontent": "tnpsc-group-gs-mains-test-series-2023-module__HT_osa__admissiongreencontent",
  "classesborder": "tnpsc-group-gs-mains-test-series-2023-module__HT_osa__classesborder",
  "facultyborder3": "tnpsc-group-gs-mains-test-series-2023-module__HT_osa__facultyborder3",
  "normalbutton": "tnpsc-group-gs-mains-test-series-2023-module__HT_osa__normalbutton",
  "normalbutton1": "tnpsc-group-gs-mains-test-series-2023-module__HT_osa__normalbutton1",
  "normalbutton2": "tnpsc-group-gs-mains-test-series-2023-module__HT_osa__normalbutton2",
  "pagemaintitle": "tnpsc-group-gs-mains-test-series-2023-module__HT_osa__pagemaintitle",
  "paybill": "tnpsc-group-gs-mains-test-series-2023-module__HT_osa__paybill",
  "paybills": "tnpsc-group-gs-mains-test-series-2023-module__HT_osa__paybills",
  "sectionredtitle": "tnpsc-group-gs-mains-test-series-2023-module__HT_osa__sectionredtitle",
  "sectionsubtitle": "tnpsc-group-gs-mains-test-series-2023-module__HT_osa__sectionsubtitle",
  "sectiontitle": "tnpsc-group-gs-mains-test-series-2023-module__HT_osa__sectiontitle",
  "tableheading": "tnpsc-group-gs-mains-test-series-2023-module__HT_osa__tableheading",
  "tablepara": "tnpsc-group-gs-mains-test-series-2023-module__HT_osa__tablepara",
  "tablescroll": "tnpsc-group-gs-mains-test-series-2023-module__HT_osa__tablescroll",
});
